import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import bgLogin from './locales/bg/login.json';
import enLogin from './locales/en/login.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      bg: {
        translation: bgLogin,
      },
      en: {
        translation: enLogin,
      },
    },
    lng: 'bg',
    fallbackLng: 'bg',
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'translation',
  });

export default i18n;
